// import React, { useState, useEffect, useCallback } from 'react';
// import { useSelector } from 'react-redux';
// import {
//   getGSTR1,
//   getGSTR3B,
//   downloadGSTR1CSV,
//   downloadGSTR1PDF,
//   downloadGSTR3BCSV,
//   downloadGSTR3BPDF,
//   getGSTDashboard,
//   getGSTInvoices,
//   getGSTInvoiceById,
//   generateGSTInvoices,
//   cancelGSTInvoice,
//   getGSTRates,
// } from '../../Services/Operations/ProductAPI';
// import '../../Styles/GSTAdmin.css';

// const SkeletonSummaryCard = () => (
//   <div className="summary-card skeleton">
//     <div className="card-header">
//       <div>
//         <div className="skeleton-title"></div>
//         <div className="skeleton-value"></div>
//         <div className="skeleton-change"></div>
//       </div>
//       <div className="skeleton-icon"></div>
//     </div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-status"></div></td>
//     <td><div className="skeleton-action"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>Invoice No.</th>
//           <th>PNR</th>
//           <th>Date</th>
//           <th>Route</th>
//           <th>Taxable Value</th>
//           <th>GST Rate</th>
//           <th>CGST</th>
//           <th>SGST</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const GSTAdminPanel = () => {
//   const [activeTab, setActiveTab] = useState('dashboard');
//   const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
//   const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
//   const [loading, setLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(20);
  
//   const [dashboardData, setDashboardData] = useState(null);
//   const [gstr1Data, setGstr1Data] = useState(null);
//   const [gstr3bData, setGstr3bData] = useState(null);
//   const [invoices, setInvoices] = useState([]);
//   const [selectedInvoice, setSelectedInvoice] = useState(null);
//   const [showInvoiceModal, setShowInvoiceModal] = useState(false);
//   const [gstRates, setGstRates] = useState([]);
//   const [generatingInvoices, setGeneratingInvoices] = useState(false);
//   const [cancellingInvoice, setCancellingInvoice] = useState(false);
//   const [notification, setNotification] = useState({ show: false, message: '', type: '' });
//   const [pagination, setPagination] = useState({ page: 1, limit: 20, total: 0, pages: 1 });
//   const [error, setError] = useState(null);
  
//   const [filters, setFilters] = useState({
//     status: '',
//     month: '',
//     year: '',
//     busOwner: ''
//   });

//   const { token } = useSelector(state => state.user);

//   const showNotification = (message, type = 'success') => {
//     setNotification({ show: true, message, type });
//     setTimeout(() => setNotification({ show: false, message: '', type: '' }), 5000);
//   };

//   const fetchDashboardData = useCallback(async () => {
//     if (!token) return;
//     try {
//       setLoading(true);
//       const response = await getGSTDashboard(selectedYear, token);
//       if (response.success) {
//         setDashboardData(response.data);
//         setError(null);
//       } else {
//         setError('Failed to load dashboard data');
//       }
//     } catch (error) {
//       console.error('Error fetching dashboard:', error);
//       setError(error.response?.data?.message || 'Failed to load dashboard data');
//       showNotification('Failed to load dashboard data', 'error');
//     } finally {
//       setLoading(false);
//     }
//   }, [selectedYear, token]);

//   const fetchGSTR1Data = useCallback(async () => {
//     if (!token) return;
//     try {
//       setLoading(true);
//       const response = await getGSTR1(selectedMonth, selectedYear, null, token);
//       if (response.success) {
//         setGstr1Data(response.data);
//         setError(null);
//       } else {
//         setError('Failed to load GSTR-1 data');
//       }
//     } catch (error) {
//       console.error('Error fetching GSTR-1:', error);
//       setError(error.response?.data?.message || 'Failed to load GSTR-1 data');
//       showNotification('Failed to load GSTR-1 data', 'error');
//     } finally {
//       setLoading(false);
//     }
//   }, [selectedMonth, selectedYear, token]);

//   const fetchGSTR3BData = useCallback(async () => {
//     if (!token) return;
//     try {
//       setLoading(true);
//       const response = await getGSTR3B(selectedMonth, selectedYear, null, token);
//       if (response.success) {
//         setGstr3bData(response.data);
//         setError(null);
//       } else {
//         setError('Failed to load GSTR-3B data');
//       }
//     } catch (error) {
//       console.error('Error fetching GSTR-3B:', error);
//       setError(error.response?.data?.message || 'Failed to load GSTR-3B data');
//       showNotification('Failed to load GSTR-3B data', 'error');
//     } finally {
//       setLoading(false);
//     }
//   }, [selectedMonth, selectedYear, token]);

//   const fetchInvoices = useCallback(async () => {
//     if (!token) return;
//     try {
//       setLoading(true);
//       const response = await getGSTInvoices(currentPage, itemsPerPage, filters, token);
//       if (response.success) {
//         setInvoices(response.data.invoices);
//         setPagination(response.data.pagination);
//         setError(null);
//       } else {
//         setError('Failed to load invoices');
//       }
//     } catch (error) {
//       console.error('Error fetching invoices:', error);
//       setError(error.response?.data?.message || 'Failed to load invoices');
//       showNotification('Failed to load invoices', 'error');
//     } finally {
//       setLoading(false);
//     }
//   }, [currentPage, itemsPerPage, filters, token]);

//   const fetchGSTRates = useCallback(async () => {
//     if (!token) return;
//     try {
//       const response = await getGSTRates({}, token);
//       if (response.success) {
//         setGstRates(response.data);
//       }
//     } catch (error) {
//       console.error('Error fetching GST rates:', error);
//     }
//   }, [token]);

//   const handleGenerateInvoices = async () => {
//     if (!token) {
//       showNotification('Please login first', 'error');
//       return;
//     }
//     setGeneratingInvoices(true);
//     try {
//       const response = await generateGSTInvoices(selectedMonth, selectedYear, token);
//       if (response.success) {
//         showNotification(response.message, 'success');
//         fetchInvoices();
//         fetchDashboardData();
//       } else {
//         showNotification(response.message || 'Failed to generate invoices', 'error');
//       }
//     } catch (error) {
//       console.error('Error generating invoices:', error);
//       showNotification(error.response?.data?.message || 'Failed to generate invoices', 'error');
//     } finally {
//       setGeneratingInvoices(false);
//     }
//   };

//   const handleCancelInvoice = async (invoiceId, reason) => {
//     if (!token) {
//       showNotification('Please login first', 'error');
//       return;
//     }
//     setCancellingInvoice(true);
//     try {
//       const response = await cancelGSTInvoice(invoiceId, reason, token);
//       if (response.success) {
//         showNotification('Invoice cancelled and credit note created', 'success');
//         fetchInvoices();
//         fetchDashboardData();
//         setShowInvoiceModal(false);
//       } else {
//         showNotification(response.message || 'Failed to cancel invoice', 'error');
//       }
//     } catch (error) {
//       console.error('Error cancelling invoice:', error);
//       showNotification(error.response?.data?.message || 'Failed to cancel invoice', 'error');
//     } finally {
//       setCancellingInvoice(false);
//     }
//   };

//   const handleViewInvoice = async (invoiceId) => {
//     if (!token) {
//       showNotification('Please login first', 'error');
//       return;
//     }
//     try {
//       setLoading(true);
//       const response = await getGSTInvoiceById(invoiceId, token);
//       if (response.success) {
//         setSelectedInvoice(response.data);
//         setShowInvoiceModal(true);
//       } else {
//         showNotification('Failed to load invoice details', 'error');
//       }
//     } catch (error) {
//       console.error('Error fetching invoice details:', error);
//       showNotification('Failed to load invoice details', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDownloadGSTR1CSV = async () => {
//     if (!token) {
//       showNotification('Please login first', 'error');
//       return;
//     }
//     try {
//       const blob = await downloadGSTR1CSV(selectedMonth, selectedYear, null, token);
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = `GSTR1_${selectedMonth}_${selectedYear}.csv`;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       window.URL.revokeObjectURL(url);
//       showNotification('GSTR-1 CSV downloaded successfully', 'success');
//     } catch (error) {
//       console.error('Error downloading GSTR-1 CSV:', error);
//       showNotification('Failed to download GSTR-1 CSV', 'error');
//     }
//   };

//   const handleDownloadGSTR1PDF = async () => {
//     if (!token) {
//       showNotification('Please login first', 'error');
//       return;
//     }
//     try {
//       const blob = await downloadGSTR1PDF(selectedMonth, selectedYear, null, token);
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = `GSTR1_${selectedMonth}_${selectedYear}.pdf`;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       window.URL.revokeObjectURL(url);
//       showNotification('GSTR-1 PDF downloaded successfully', 'success');
//     } catch (error) {
//       console.error('Error downloading GSTR-1 PDF:', error);
//       showNotification('Failed to download GSTR-1 PDF', 'error');
//     }
//   };

//   const handleDownloadGSTR3BCSV = async () => {
//     if (!token) {
//       showNotification('Please login first', 'error');
//       return;
//     }
//     try {
//       const blob = await downloadGSTR3BCSV(selectedMonth, selectedYear, null, token);
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = `GSTR3B_${selectedMonth}_${selectedYear}.csv`;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       window.URL.revokeObjectURL(url);
//       showNotification('GSTR-3B CSV downloaded successfully', 'success');
//     } catch (error) {
//       console.error('Error downloading GSTR-3B CSV:', error);
//       showNotification('Failed to download GSTR-3B CSV', 'error');
//     }
//   };

//   const handleDownloadGSTR3BPDF = async () => {
//     if (!token) {
//       showNotification('Please login first', 'error');
//       return;
//     }
//     try {
//       const blob = await downloadGSTR3BPDF(selectedMonth, selectedYear, null, token);
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = `GSTR3B_${selectedMonth}_${selectedYear}.pdf`;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       window.URL.revokeObjectURL(url);
//       showNotification('GSTR-3B PDF downloaded successfully', 'success');
//     } catch (error) {
//       console.error('Error downloading GSTR-3B PDF:', error);
//       showNotification('Failed to download GSTR-3B PDF', 'error');
//     }
//   };

//   const handleRefresh = () => {
//     if (activeTab === 'dashboard') {
//       fetchDashboardData();
//     } else if (activeTab === 'gstr1') {
//       fetchGSTR1Data();
//     } else if (activeTab === 'gstr3b') {
//       fetchGSTR3BData();
//     } else if (activeTab === 'invoices') {
//       setCurrentPage(1);
//       fetchInvoices();
//     }
//   };

//   useEffect(() => {
//     if (token) {
//       fetchDashboardData();
//       fetchGSTRates();
//     }
//   }, [fetchDashboardData, fetchGSTRates, token]);

//   useEffect(() => {
//     if (token) {
//       if (activeTab === 'gstr1') {
//         fetchGSTR1Data();
//       } else if (activeTab === 'gstr3b') {
//         fetchGSTR3BData();
//       } else if (activeTab === 'invoices') {
//         fetchInvoices();
//       }
//     }
//   }, [activeTab, fetchGSTR1Data, fetchGSTR3BData, fetchInvoices, token]);

//   const formatCurrency = (amount) => {
//     if (!amount && amount !== 0) return '₹0';
//     return `₹${amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-IN');
//   };

//   const getMonthName = (month) => {
//     const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
//     return months[month - 1];
//   };

//   const getSummaryCards = () => {
//     if (!dashboardData) return [];
//     return [
//       { title: 'Total Invoices', value: dashboardData.currentMonth?.count || 0, change: '+0%', icon: '📄', color: 'blue' },
//       { title: 'Total Taxable Value', value: formatCurrency(dashboardData.currentMonth?.totalTaxable || 0), change: '+0%', icon: '💰', color: 'green' },
//       { title: 'Total GST Collected', value: formatCurrency(dashboardData.currentMonth?.totalGST || 0), change: '+0%', icon: '🏷️', color: 'purple' },
//       { title: 'Pending Invoices', value: dashboardData.pendingInvoiceGeneration || 0, change: '⚠️', icon: '⏳', color: 'orange' },
//     ];
//   };

//   if (loading && !dashboardData && activeTab === 'dashboard') {
//     return (
//       <div className="gst-admin-container">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>
//         <div className="summary-grid">
//           {[1, 2, 3, 4].map((i) => <SkeletonSummaryCard key={i} />)}
//         </div>
//         <div className="skeleton-table"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="gst-admin-container">

//       {notification.show && (
//         <div className={`notification notification-${notification.type}`}>
//           <span>{notification.message}</span>
//           <button onClick={() => setNotification({ show: false, message: '', type: '' })}>×</button>
//         </div>
//       )}


//       {error && (
//         <div className="error-message">
//           {error}
//           <button onClick={() => setError(null)}>×</button>
//         </div>
//       )}


//       <header className="gst-header">
//         <div className="header-content">
//           <div className="logo-section">
//             <div className="logo-icon">
//               <span>🚌</span>
//             </div>
//             <div>
//               <h1 className="header-title">Roam - GST Compliance Hub</h1>
//               <p className="header-subtitle">Manage bus transport GSTR-1 & GSTR-3B returns</p>
//             </div>
//           </div>
//           <div className="header-actions">
//             <div className="period-selector">
//               <span className="calendar-icon">📅</span>
//               <select 
//                 className="period-dropdown"
//                 value={selectedMonth}
//                 onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
//               >
//                 {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(m => (
//                   <option key={m} value={m}>{getMonthName(m)}</option>
//                 ))}
//               </select>
//               <select 
//                 className="period-dropdown"
//                 value={selectedYear}
//                 onChange={(e) => setSelectedYear(parseInt(e.target.value))}
//               >
//                 {[2024, 2025, 2026, 2027].map(y => (
//                   <option key={y} value={y}>{y}</option>
//                 ))}
//               </select>
//             </div>
//             <button className="btn-primary" onClick={handleGenerateInvoices} disabled={generatingInvoices}>
//               {generatingInvoices ? 'Generating...' : '+ Generate Invoices'}
//             </button>
//             <button className="refresh-btn" onClick={handleRefresh} disabled={loading}>
//               🔄 Refresh
//             </button>
//           </div>
//         </div>
//       </header>

//       <div className="main-content">

//         <div className="summary-grid">
//           {getSummaryCards().map((card, idx) => (
//             <div key={idx} className={`summary-card summary-card-${card.color}`}>
//               <div className="card-header">
//                 <div>
//                   <p className="card-title">{card.title}</p>
//                   <h3 className="card-value">{card.value}</h3>
//                   <p className={`card-change ${card.change.startsWith('+') ? 'change-positive' : 'change-negative'}`}>
//                     {card.change} from last month
//                   </p>
//                 </div>
//                 <div className={`card-icon card-icon-${card.color}`}>
//                   <span>{card.icon}</span>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>


//         <div className="tabs-container">
//           <div className="tabs-header">
//             <button
//               onClick={() => setActiveTab('dashboard')}
//               className={`tab-button ${activeTab === 'dashboard' ? 'tab-active' : ''}`}
//             >
//               <span className="tab-icon">📊</span>
//               <span>Dashboard</span>
//             </button>
//             <button
//               onClick={() => setActiveTab('gstr1')}
//               className={`tab-button ${activeTab === 'gstr1' ? 'tab-active' : ''}`}
//             >
//               <span className="tab-icon">📋</span>
//               <span>GSTR-1</span>
//             </button>
//             <button
//               onClick={() => setActiveTab('gstr3b')}
//               className={`tab-button ${activeTab === 'gstr3b' ? 'tab-active' : ''}`}
//             >
//               <span className="tab-icon">📊</span>
//               <span>GSTR-3B</span>
//             </button>
//             <button
//               onClick={() => setActiveTab('invoices')}
//               className={`tab-button ${activeTab === 'invoices' ? 'tab-active' : ''}`}
//             >
//               <span className="tab-icon">📄</span>
//               <span>Invoices</span>
//             </button>
//             <button
//               onClick={() => setActiveTab('rates')}
//               className={`tab-button ${activeTab === 'rates' ? 'tab-active' : ''}`}
//             >
//               <span className="tab-icon">⚙️</span>
//               <span>GST Rates</span>
//             </button>
//           </div>

//           <div className="tab-content">

//             {activeTab === 'dashboard' && dashboardData && (
//               <div className="dashboard-content">
//                 {loading && <div className="loading-overlay"><div className="loading-spinner"></div></div>}

//                 <div className="trend-chart">
//                   <h3>Monthly GST Collection Trend</h3>
//                   <div className="chart-bars">
//                     {dashboardData.financialYearMonthly?.map((item, idx) => (
//                       <div key={idx} className="chart-bar-container">
//                         <div 
//                           className="chart-bar" 
//                           style={{ 
//                             height: `${Math.min((item.totalGST / 10000) * 100, 100)}%`,
//                             backgroundColor: '#4F46E5'
//                           }}
//                         ></div>
//                         <span className="chart-label">{getMonthName(item._id.month).slice(0, 3)}</span>
//                         <span className="chart-value">{formatCurrency(item.totalGST)}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <div className="financial-summary">
//                   <h3>Financial Year {dashboardData.financialYear} Summary</h3>
//                   <div className="summary-stats-grid">
//                     <div className="stat-item">
//                       <span className="stat-label">Total Invoices</span>
//                       <span className="stat-value">{dashboardData.financialYearMonthly?.reduce((sum, i) => sum + i.count, 0) || 0}</span>
//                     </div>
//                     <div className="stat-item">
//                       <span className="stat-label">Total GST Collected</span>
//                       <span className="stat-value">{formatCurrency(dashboardData.financialYearMonthly?.reduce((sum, i) => sum + i.totalGST, 0) || 0)}</span>
//                     </div>
//                     <div className="stat-item">
//                       <span className="stat-label">Total Invoice Value</span>
//                       <span className="stat-value">{formatCurrency(dashboardData.financialYearMonthly?.reduce((sum, i) => sum + i.totalValue, 0) || 0)}</span>
//                     </div>
//                   </div>
//                 </div>

//                 {dashboardData.pendingInvoiceGeneration > 0 && (
//                   <div className="pending-alert">
//                     <div className="alert-icon">⚠️</div>
//                     <div className="alert-content">
//                       <h4>{dashboardData.pendingInvoiceGeneration} bookings pending invoice generation</h4>
//                       <p>Click "Generate Invoices" to create GST invoices for these bookings</p>
//                     </div>
//                     <button className="alert-action" onClick={handleGenerateInvoices}>
//                       Generate Now
//                     </button>
//                   </div>
//                 )}
//               </div>
//             )}


//             {activeTab === 'gstr1' && gstr1Data && (
//               <div className="gstr1-content">
//                 {loading && <div className="loading-overlay"><div className="loading-spinner"></div></div>}
//                 <div className="action-bar">
//                   <div className="action-buttons">
//                     <button className="btn-secondary" onClick={handleDownloadGSTR1CSV}>
//                       <span>📥</span>
//                       <span>Download CSV</span>
//                     </button>
//                     <button className="btn-secondary" onClick={handleDownloadGSTR1PDF}>
//                       <span>📄</span>
//                       <span>Download PDF</span>
//                     </button>
//                   </div>
//                 </div>

//                 <div className="summary-section">
//                   <h3>GSTR-1 Summary - {getMonthName(selectedMonth)} {selectedYear}</h3>
//                   <div className="summary-grid-small">
//                     <div className="summary-item">
//                       <span className="summary-label">Total Invoices</span>
//                       <span className="summary-value">{gstr1Data.summary?.totalInvoices || 0}</span>
//                     </div>
//                     <div className="summary-item">
//                       <span className="summary-label">Total Taxable Value</span>
//                       <span className="summary-value">{formatCurrency(gstr1Data.summary?.totalTaxableValue || 0)}</span>
//                     </div>
//                     <div className="summary-item">
//                       <span className="summary-label">Total CGST</span>
//                       <span className="summary-value">{formatCurrency(gstr1Data.summary?.totalCGST || 0)}</span>
//                     </div>
//                     <div className="summary-item">
//                       <span className="summary-label">Total SGST</span>
//                       <span className="summary-value">{formatCurrency(gstr1Data.summary?.totalSGST || 0)}</span>
//                     </div>
//                     <div className="summary-item">
//                       <span className="summary-label">Total IGST</span>
//                       <span className="summary-value">{formatCurrency(gstr1Data.summary?.totalIGST || 0)}</span>
//                     </div>
//                     <div className="summary-item">
//                       <span className="summary-label">Total GST</span>
//                       <span className="summary-value">{formatCurrency(gstr1Data.summary?.totalGST || 0)}</span>
//                     </div>
//                   </div>
//                 </div>


//               </div>
//             )}


//             {activeTab === 'gstr3b' && gstr3bData && (
//               <div className="gstr3b-content">
//                 {loading && <div className="loading-overlay"><div className="loading-spinner"></div></div>}

//               </div>
//             )}


//             {activeTab === 'invoices' && (
//               <div className="invoices-content">
//                 <div className="filters-bar">
//                   <div className="search-box">
//                     <span className="search-icon">🔍</span>
//                     <input
//                       type="text"
//                       placeholder="Search by invoice number or PNR..."
//                       className="search-input"
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                     />
//                   </div>
//                   <select 
//                     className="filter-select"
//                     value={filters.status}
//                     onChange={(e) => setFilters({ ...filters, status: e.target.value })}
//                   >
//                     <option value="">All Status</option>
//                     <option value="active">Active</option>
//                     <option value="cancelled">Cancelled</option>
//                     <option value="credit_note">Credit Note</option>
//                   </select>
//                   <button className="btn-refresh" onClick={handleRefresh}>
//                     🔄 Refresh
//                   </button>
//                 </div>


//                 <div className="table-container">
//                   <table className="data-table">
//                     <thead>
//                       <tr>
//                         <th>Invoice No.</th>
//                         <th>PNR</th>
//                         <th>Date</th>
//                         <th>Route</th>
//                         <th className="text-right">Taxable Value</th>
//                         <th className="text-right">CGST</th>
//                         <th className="text-right">SGST</th>
//                         <th className="text-right">Total</th>
//                         <th className="text-center">Status</th>
//                         <th className="text-center">Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {loading && invoices.length === 0 ? (
//                         [...Array(5)].map((_, i) => <SkeletonTableRow key={i} />)
//                       ) : invoices.length === 0 ? (
//                         <tr>
//                           <td colSpan="10" className="no-data">No invoices found</td>
//                         </tr>
//                       ) : (
//                         invoices.map((invoice) => (
//                           <tr key={invoice._id}>
//                             <td>{invoice.invoiceNumber}</td>
//                             <td>{invoice.pnr}</td>
//                             <td>{formatDate(invoice.invoiceDate)}</td>
//                             <td>
//                               {invoice.booking?.route?.from} → {invoice.booking?.route?.to}
//                             </td>
//                             <td className="text-right">{formatCurrency(invoice.totalTaxableValue)}</td>
//                             <td className="text-right">{formatCurrency(invoice.totalCGST)}</td>
//                             <td className="text-right">{formatCurrency(invoice.totalSGST)}</td>
//                             <td className="text-right">{formatCurrency(invoice.totalInvoiceValue)}</td>
//                             <td className="text-center">
//                               <span className={`status-badge status-${invoice.status}`}>
//                                 {invoice.status === 'active' ? 'Active' : invoice.status === 'cancelled' ? 'Cancelled' : 'Credit Note'}
//                               </span>
//                             </td>
//                             <td className="text-center">
//                               <button 
//                                 className="action-btn view" 
//                                 onClick={() => handleViewInvoice(invoice._id)}
//                                 title="View"
//                               >
//                                 👁️
//                               </button>
//                               {invoice.status === 'active' && (
//                                 <button 
//                                   className="action-btn cancel" 
//                                   onClick={() => {
//                                     const reason = prompt('Enter cancellation reason:');
//                                     if (reason) handleCancelInvoice(invoice._id, reason);
//                                   }}
//                                   title="Cancel"
//                                 >
//                                   ❌
//                                 </button>
//                               )}
//                             </td>
//                           </tr>
//                         ))
//                       )}
//                     </tbody>
//                   </table>
//                 </div>


//                 {pagination.pages > 1 && (
//                   <div className="pagination-container">
//                     <div className="pagination-info">
//                       Showing {invoices.length} of {pagination.total} invoices
//                       (Page {currentPage} of {pagination.pages})
//                     </div>
//                     <div className="pagination-controls">
//                       <button 
//                         className="pagination-btn"
//                         disabled={currentPage === 1 || loading}
//                         onClick={() => setCurrentPage(currentPage - 1)}
//                       >
//                         Previous
//                       </button>
//                       <span className="page-number active">{currentPage}</span>
//                       <button 
//                         className="pagination-btn"
//                         disabled={currentPage === pagination.pages || loading}
//                         onClick={() => setCurrentPage(currentPage + 1)}
//                       >
//                         Next
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}


//             {activeTab === 'rates' && (
//               <div className="rates-content">
//                 <div className="table-section">
//                   <h3>GST Rates Configuration</h3>
//                   <div className="table-container">
//                     <table className="data-table">
//                       <thead>
//                         <tr>
//                           <th>Service Type</th>
//                           <th>Tax Type</th>
//                           <th className="text-right">GST Rate (%)</th>
//                           <th className="text-right">CGST (%)</th>
//                           <th className="text-right">SGST (%)</th>
//                           <th>Status</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         <tr>
//                           <td>AC Bus</td>
//                           <td>Intra-State</td>
//                           <td className="text-right">5%</td>
//                           <td className="text-right">2.5%</td>
//                           <td className="text-right">2.5%</td>
//                           <td><span className="status-badge status-active">Active</span></td>
//                         </tr>
//                         <tr>
//                           <td>AC Bus</td>
//                           <td>Inter-State</td>
//                           <td className="text-right">5%</td>
//                           <td className="text-right">-</td>
//                           <td className="text-right">-</td>
//                           <td><span className="status-badge status-active">Active</span></td>
//                         </tr>
//                         <tr>
//                           <td>Non-AC Bus</td>
//                           <td>All</td>
//                           <td className="text-right">0%</td>
//                           <td className="text-right">0%</td>
//                           <td className="text-right">0%</td>
//                           <td><span className="status-badge status-exempt">Exempt</span></td>
//                         </tr>
//                         <tr>
//                           <td>Luxury Coach</td>
//                           <td>Intra-State</td>
//                           <td className="text-right">12%</td>
//                           <td className="text-right">6%</td>
//                           <td className="text-right">6%</td>
//                           <td><span className="status-badge status-active">Active</span></td>
//                         </tr>
//                         <tr>
//                           <td>Luxury Coach</td>
//                           <td>Inter-State</td>
//                           <td className="text-right">12%</td>
//                           <td className="text-right">-</td>
//                           <td className="text-right">-</td>
//                           <td><span className="status-badge status-active">Active</span></td>
//                         </tr>
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>

//                 <div className="gst-info-box">
//                   <span className="info-icon">ℹ️</span>
//                   <div className="info-content">
//                     <strong>GST Rates Applied:</strong> AC Buses @ 5% IGST/CGST+SGST | Non-AC Buses @ 0% (Exempt) | Luxury Coaches @ 12%
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>


//       {showInvoiceModal && selectedInvoice && (
//         <div className="modal-overlay" onClick={() => setShowInvoiceModal(false)}>
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h2>Invoice Details</h2>
//               <button className="modal-close" onClick={() => setShowInvoiceModal(false)}>×</button>
//             </div>
//             <div className="modal-body">
//               <div className="invoice-details">
//                 <div className="detail-row">
//                   <span className="detail-label">Invoice Number:</span>
//                   <span className="detail-value">{selectedInvoice.invoiceNumber}</span>
//                 </div>
//                 <div className="detail-row">
//                   <span className="detail-label">PNR:</span>
//                   <span className="detail-value">{selectedInvoice.pnr}</span>
//                 </div>
//                 <div className="detail-row">
//                   <span className="detail-label">Invoice Date:</span>
//                   <span className="detail-value">{formatDate(selectedInvoice.invoiceDate)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <span className="detail-label">Financial Year:</span>
//                   <span className="detail-value">{selectedInvoice.financialYear}</span>
//                 </div>
//                 <div className="detail-row">
//                   <span className="detail-label">Recipient:</span>
//                   <span className="detail-value">{selectedInvoice.recipient?.name}</span>
//                 </div>
//                 <div className="detail-row">
//                   <span className="detail-label">Place of Supply:</span>
//                   <span className="detail-value">{selectedInvoice.placeOfSupply?.stateName}</span>
//                 </div>
//                 <div className="detail-row">
//                   <span className="detail-label">Inter-State:</span>
//                   <span className="detail-value">{selectedInvoice.isInterState ? 'Yes' : 'No'}</span>
//                 </div>
//                 <hr />
//                 <div className="detail-row">
//                   <span className="detail-label">Taxable Value:</span>
//                   <span className="detail-value">{formatCurrency(selectedInvoice.totalTaxableValue)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <span className="detail-label">CGST:</span>
//                   <span className="detail-value">{formatCurrency(selectedInvoice.totalCGST)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <span className="detail-label">SGST:</span>
//                   <span className="detail-value">{formatCurrency(selectedInvoice.totalSGST)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <span className="detail-label">Total Invoice Value:</span>
//                   <span className="detail-value">{formatCurrency(selectedInvoice.totalInvoiceValue)}</span>
//                 </div>
//                 <hr />
//                 <div className="detail-row">
//                   <span className="detail-label">Status:</span>
//                   <span className={`detail-value status-${selectedInvoice.status}`}>
//                     {selectedInvoice.status === 'active' ? 'Active' : selectedInvoice.status === 'cancelled' ? 'Cancelled' : 'Credit Note'}
//                   </span>
//                 </div>
//                 {selectedInvoice.notes && (
//                   <div className="detail-row">
//                     <span className="detail-label">Notes:</span>
//                     <span className="detail-value">{selectedInvoice.notes}</span>
//                   </div>
//                 )}
//               </div>
//             </div>
//             <div className="modal-footer">
//               {selectedInvoice.status === 'active' && (
//                 <button 
//                   className="btn-danger"
//                   onClick={() => {
//                     const reason = prompt('Enter cancellation reason:');
//                     if (reason) {
//                       handleCancelInvoice(selectedInvoice._id, reason);
//                     }
//                   }}
//                   disabled={cancellingInvoice}
//                 >
//                   {cancellingInvoice ? 'Cancelling...' : 'Cancel Invoice'}
//                 </button>
//               )}
//               <button className="btn-secondary" onClick={() => setShowInvoiceModal(false)}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default GSTAdminPanel;

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions (pagination…)
import '../../Styles/CustomerReport.css';       // cr- additions (error bar, loading)
import '../../Styles/GSTManagement.css';        // gst- additions (tax badges, panels)
import '../../Styles/GSTAdmin.css';             // GST admin-only additions (load LAST)
import {
  getGSTR1, getGSTR3B, downloadGSTR1CSV, downloadGSTR1PDF, downloadGSTR3BCSV, downloadGSTR3BPDF,
  getGSTDashboard, getGSTInvoices, getGSTInvoiceById, generateGSTInvoices, cancelGSTInvoice, getGSTRates
} from '../../Services/Operations/ProductAPI';
import { Icon, BusSvg, StatCard, Field, Pagination } from './PrimaryUI';

// ---------- helpers ----------
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const YEARS = [2024, 2025, 2026, 2027];
const TABS = [
  { key: 'dashboard', label: 'Dashboard', icon: 'grid' },
  { key: 'gstr1', label: 'GSTR-1', icon: 'list' },
  { key: 'gstr3b', label: 'GSTR-3B', icon: 'ticket' },
  { key: 'invoices', label: 'Invoices', icon: 'wallet' },
  { key: 'rates', label: 'GST Rates', icon: 'edit' }
];
const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-GB').replace(/\//g, '.') : 'N/A');
const errMsg = (err, fb) => err?.response?.data?.message || err?.message || fb;
const invStatus = (s) => (s === 'active' ? { cls: 'active', label: 'Active' } : s === 'cancelled' ? { cls: 'inactive', label: 'Cancelled' } : { cls: 'info', label: 'Credit Note' });
const StatusPill = ({ value }) => { const s = invStatus(value); return <span className={`prm-status ${s.cls}`}>{s.label}</span>; };

const prettyKey = (k) => k.replace(/([A-Z])/g, ' $1').replace(/[_-]/g, ' ').replace(/^./, c => c.toUpperCase()).trim();
const isMoneyKey = (k) => /taxable|value|amount|cgst|sgst|igst|gst|tax|itc|liability|total(?!Invoices|Count)/i.test(k) && !/count|invoices|number/i.test(k);
const fmtVal = (k, v) => (typeof v === 'number' ? (isMoneyKey(k) ? inr(v) : v.toLocaleString('en-IN')) : typeof v === 'boolean' ? (v ? 'Yes' : 'No') : v ?? 'N/A');

const Skeleton = ({ n = 3 }) => (
  <div className="prm-grid">{Array.from({ length: n }).map((_, i) => (
    <div className="prm-skel" key={i}><div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" /></div>
  ))}</div>
);

// Generic renderer for a returns object (used by GSTR-3B whose shape is backend-defined)
const ReturnSections = ({ data }) => {
  const root = data?.summary || data || {};
  const flat = Object.entries(root).filter(([, v]) => v === null || typeof v !== 'object');
  const groups = Object.entries(root).filter(([, v]) => v && typeof v === 'object' && !Array.isArray(v));
  const lists = Object.entries(root).filter(([, v]) => Array.isArray(v));
  return (
    <>
      {flat.length > 0 && (
        <div className="ga-kv-grid">
          {flat.map(([k, v]) => <div key={k} className="ga-kv"><span>{prettyKey(k)}</span><b>{fmtVal(k, v)}</b></div>)}
        </div>
      )}
      {groups.map(([g, obj]) => (
        <div key={g} className="gst-panel ga-section">
          <div className="prm-section-title">{prettyKey(g)}</div>
          <div className="gst-result-rows">
            {Object.entries(obj).filter(([, v]) => typeof v !== 'object' || v === null).map(([k, v]) => (
              <div key={k}><span>{prettyKey(k)}</span><b>{fmtVal(k, v)}</b></div>
            ))}
          </div>
        </div>
      ))}
      {lists.map(([k, arr]) => arr.length > 0 && typeof arr[0] === 'object' && (
        <div key={k} className="ga-section">
          <div className="prm-section-title">{prettyKey(k)}</div>
          <div className="prm-table-wrap"><table className="prm-table">
            <thead><tr>{Object.keys(arr[0]).filter(c => typeof arr[0][c] !== 'object').map(c => <th key={c}>{prettyKey(c)}</th>)}</tr></thead>
            <tbody>{arr.map((row, i) => (
              <tr key={i}>{Object.keys(arr[0]).filter(c => typeof arr[0][c] !== 'object').map(c => <td key={c}>{fmtVal(c, row[c])}</td>)}</tr>
            ))}</tbody>
          </table></div>
        </div>
      ))}
    </>
  );
};

// ============================================================
// MAIN
// ============================================================
const GSTAdminPanel = () => {
  const { token } = useSelector(state => state.user);

  const [activeTab, setActiveTab] = useState('dashboard');
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [dashboard, setDashboard] = useState(null);
  const [gstr1, setGstr1] = useState(null);
  const [gstr3b, setGstr3b] = useState(null);
  const [rates, setRates] = useState([]);

  const [invoices, setInvoices] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [statusFilter, setStatusFilter] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  const [generating, setGenerating] = useState(false);
  const [viewInvoice, setViewInvoice] = useState(null);
  const [cancelTarget, setCancelTarget] = useState(null);
  const [cancelReason, setCancelReason] = useState('');
  const [cancelling, setCancelling] = useState(false);

  // ---------- fetchers ----------
  const run = async (fn, okSet, failMsg) => {
    if (!token) return;
    try {
      setLoading(true); setError(null);
      const res = await fn();
      if (res?.success) okSet(res); else setError(res?.message || failMsg);
    } catch (err) { setError(errMsg(err, failMsg)); }
    finally { setLoading(false); }
  };

  const fetchDashboard = useCallback(() => run(() => getGSTDashboard(year, token), r => setDashboard(r.data), 'Failed to load dashboard data'), [year, token]); // eslint-disable-line
  const fetchGSTR1 = useCallback(() => run(() => getGSTR1(month, year, null, token), r => setGstr1(r.data), 'Failed to load GSTR-1 data'), [month, year, token]); // eslint-disable-line
  const fetchGSTR3B = useCallback(() => run(() => getGSTR3B(month, year, null, token), r => setGstr3b(r.data), 'Failed to load GSTR-3B data'), [month, year, token]); // eslint-disable-line
  const fetchInvoices = useCallback(() => run(
    () => getGSTInvoices(page, pageSize, { status: statusFilter, month: '', year: '', busOwner: '' }, token),
    r => { setInvoices(r.data?.invoices || []); setTotal(r.data?.pagination?.total || 0); }, 'Failed to load invoices'
  ), [page, pageSize, statusFilter, token]); // eslint-disable-line
  const fetchRates = useCallback(async () => {
    if (!token) return;
    try { const r = await getGSTRates({}, token); if (r?.success) setRates(Array.isArray(r.data) ? r.data : (r.data?.rates || [])); } catch (e) { /* static reference shown */ }
  }, [token]);

  useEffect(() => { if (token) { fetchDashboard(); fetchRates(); } }, [fetchDashboard, fetchRates, token]);
  useEffect(() => {
    if (!token) return;
    if (activeTab === 'gstr1') fetchGSTR1();
    else if (activeTab === 'gstr3b') fetchGSTR3B();
    else if (activeTab === 'invoices') fetchInvoices();
  }, [activeTab, fetchGSTR1, fetchGSTR3B, fetchInvoices, token]);
  useEffect(() => { if (page > totalPages) setPage(totalPages); }, [page, totalPages]);

  // ---------- handlers ----------
  const refresh = () => {
    if (activeTab === 'dashboard') fetchDashboard();
    else if (activeTab === 'gstr1') fetchGSTR1();
    else if (activeTab === 'gstr3b') fetchGSTR3B();
    else if (activeTab === 'invoices') fetchInvoices();
    else fetchRates();
  };

  const handleGenerate = async () => {
    try {
      setGenerating(true);
      const res = await generateGSTInvoices(month, year, token);
      if (res?.success) { toast.success(res.message || 'Invoices generated'); fetchInvoices(); fetchDashboard(); }
      else toast.error(res?.message || 'Failed to generate invoices');
    } catch (err) { toast.error(errMsg(err, 'Failed to generate invoices')); }
    finally { setGenerating(false); }
  };

  const openInvoice = async (id) => {
    try {
      const res = await getGSTInvoiceById(id, token);
      if (res?.success) setViewInvoice(res.data); else toast.error('Failed to load invoice details');
    } catch (e) { toast.error('Failed to load invoice details'); }
  };

  const startCancel = (inv) => { setCancelTarget(inv); setCancelReason(''); };
  const confirmCancel = async () => {
    if (!cancelReason.trim()) return toast.warning('Please enter a cancellation reason');
    try {
      setCancelling(true);
      const res = await cancelGSTInvoice(cancelTarget._id, cancelReason.trim(), token);
      if (res?.success) {
        toast.success('Invoice cancelled and credit note created');
        setCancelTarget(null); setViewInvoice(null); fetchInvoices(); fetchDashboard();
      } else toast.error(res?.message || 'Failed to cancel invoice');
    } catch (err) { toast.error(errMsg(err, 'Failed to cancel invoice')); }
    finally { setCancelling(false); }
  };

  const download = async (fn, name, label) => {
    try {
      const blob = await fn(month, year, null, token);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = name;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      toast.success(`${label} downloaded`);
    } catch (e) { toast.error(`Failed to download ${label}`); }
  };

  // ---------- derived ----------
  const visibleInvoices = useMemo(() => {
    const q = searchTerm.trim().toLowerCase();
    return q ? invoices.filter(i => `${i.invoiceNumber} ${i.pnr}`.toLowerCase().includes(q)) : invoices;
  }, [invoices, searchTerm]);

  const monthly = dashboard?.financialYearMonthly || [];
  const maxGST = Math.max(1, ...monthly.map(m => m.totalGST || 0));
  const fySum = (k) => monthly.reduce((s, i) => s + (i[k] || 0), 0);
  const period = `${MONTHS[month - 1]} ${year}`;
  const pending = dashboard?.pendingInvoiceGeneration || 0;

  const referenceRates = [
    ['AC Bus', 'Intra-state', '5%', '2.5%', '2.5%', 'Active'], ['AC Bus', 'Inter-state', '5%', '—', '—', 'Active'],
    ['Non-AC Bus', 'All', '0%', '0%', '0%', 'Exempt'],
    ['Luxury Coach', 'Intra-state', '12%', '6%', '6%', 'Active'], ['Luxury Coach', 'Inter-state', '12%', '—', '—', 'Active']
  ];

  // ============================================================
  if (loading && !dashboard && activeTab === 'dashboard') {
    return (
      <div className="prm-page">
        <div className="prm-hero"><div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="wallet" size={13} /> Tax &amp; Compliance</span>
          <h1>GST Compliance Hub</h1><p>Loading GST data…</p>
        </div></div>
        <div style={{ height: 24 }} /><Skeleton />
      </div>
    );
  }

  return (
    <div className="prm-page">
      {/* HERO */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true"><span className="prm-hero-roadbus"><BusSvg size={46} /></span></div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="wallet" size={13} /> Tax &amp; Compliance</span>
          <h1>GST Compliance Hub</h1>
          <p>Manage bus transport GSTR-1 and GSTR-3B returns and GST invoices for {period}.</p>
        </div>
        <div className="prm-hero-actions">
          <div className="ga-period">
            <Icon name="calendar" size={15} />
            <select value={month} onChange={e => setMonth(parseInt(e.target.value, 10))}>
              {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
            </select>
            <select value={year} onChange={e => setYear(parseInt(e.target.value, 10))}>
              {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>
          <button className="pbo-icon-btn" onClick={refresh} disabled={loading} title="Refresh"><Icon name="refresh" size={17} /></button>
          <button className="prm-add-btn" onClick={handleGenerate} disabled={generating}>
            <span className="plus">+</span> {generating ? 'Generating…' : 'Generate invoices'}
          </button>
        </div>
      </div>

      {error && <div className="cr-error"><Icon name="info" size={16} /> {error}
        <button className="prm-btn ghost sm" onClick={refresh}>Retry</button></div>}

      {/* STATS */}
      <div className="prm-stats">
        <StatCard icon="ticket" tone="indigo" label="Total Invoices" value={dashboard?.currentMonth?.count || 0} hint="This month" delay={80} />
        <StatCard icon="wallet" tone="green" label="Taxable Value" value={inr(dashboard?.currentMonth?.totalTaxable)} hint="This month" delay={160} />
        <StatCard icon="check" tone="amber" label="GST Collected" value={inr(dashboard?.currentMonth?.totalGST)} hint="This month" delay={240} />
        <StatCard icon="info" tone="cyan" label="Pending Invoices" value={pending} hint="Awaiting generation" delay={320} />
      </div>

      {/* TABS */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <div className="prm-chips">
            {TABS.map(t => (
              <button key={t.key} className={`prm-chip ${activeTab === t.key ? 'active' : ''}`} onClick={() => setActiveTab(t.key)}>
                <Icon name={t.icon} size={14} /> {t.label}
              </button>
            ))}
          </div>
        </div>
        <div className="prm-toolbar-right"><span className="prm-result-count">Period: <b>{period}</b></span></div>
      </div>

      <div className={loading ? 'cr-loading' : ''}>
        {/* ================= DASHBOARD ================= */}
        {activeTab === 'dashboard' && dashboard && (
          <>
            {pending > 0 && (
              <div className="ga-alert">
                <Icon name="info" size={20} />
                <div><b>{pending} booking{pending > 1 ? 's' : ''} pending invoice generation</b><p>Generate GST invoices for these bookings to keep your returns complete.</p></div>
                <button className="prm-btn primary sm" onClick={handleGenerate} disabled={generating}>{generating ? 'Generating…' : 'Generate now'}</button>
              </div>
            )}

            <div className="gst-panel">
              <div className="prm-section-title">Monthly GST collection — FY {dashboard.financialYear}</div>
              {monthly.length === 0 ? <p className="gst-hint">No data for this financial year yet.</p> : (
                <div className="ga-chart">
                  {monthly.map((m, i) => (
                    <div key={i} className="ga-bar" title={`${MONTHS[m._id.month - 1]}: ${inr(m.totalGST)}`}>
                      <span className="val">{inr(m.totalGST).replace(/\.00$/, '')}</span>
                      <div className="col"><div className="fill" style={{ height: `${Math.max(3, (m.totalGST / maxGST) * 100)}%`, animationDelay: `${i * 60}ms` }} /></div>
                      <span className="lbl">{MONTHS[m._id.month - 1].slice(0, 3)}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="prm-section-title">Financial year {dashboard.financialYear} summary</div>
            <div className="cr-summary">
              <div><Icon name="ticket" size={16} /><span>Total invoices</span><b>{fySum('count')}</b></div>
              <div><Icon name="wallet" size={16} /><span>GST collected</span><b>{inr(fySum('totalGST'))}</b></div>
              <div><Icon name="check" size={16} /><span>Invoice value</span><b>{inr(fySum('totalValue'))}</b></div>
            </div>
          </>
        )}

        {/* ================= GSTR-1 ================= */}
        {activeTab === 'gstr1' && (
          loading && !gstr1 ? <Skeleton n={2} /> : !gstr1 ? (
            <div className="prm-empty"><div className="icon"><Icon name="list" size={44} /></div><h3>No GSTR-1 data</h3><p>Nothing found for {period}.</p></div>
          ) : (
            <>
              <div className="ga-actions">
                <div className="prm-section-title">GSTR-1 summary — {period}</div>
                <div className="ga-dl">
                  <button className="prm-btn ghost sm" onClick={() => download(downloadGSTR1CSV, `GSTR1_${month}_${year}.csv`, 'GSTR-1 CSV')}><Icon name="download" size={14} /> CSV</button>
                  <button className="prm-btn ghost sm" onClick={() => download(downloadGSTR1PDF, `GSTR1_${month}_${year}.pdf`, 'GSTR-1 PDF')}><Icon name="download" size={14} /> PDF</button>
                </div>
              </div>
              <div className="ga-kv-grid">
                {[['Total invoices', gstr1.summary?.totalInvoices, false], ['Taxable value', gstr1.summary?.totalTaxableValue, true],
                  ['Total CGST', gstr1.summary?.totalCGST, true], ['Total SGST', gstr1.summary?.totalSGST, true],
                  ['Total IGST', gstr1.summary?.totalIGST, true], ['Total GST', gstr1.summary?.totalGST, true]].map(([l, v, money]) => (
                  <div className="ga-kv" key={l}><span>{l}</span><b>{money ? inr(v) : (v || 0)}</b></div>
                ))}
              </div>
            </>
          )
        )}

        {/* ================= GSTR-3B ================= */}
        {activeTab === 'gstr3b' && (
          loading && !gstr3b ? <Skeleton n={2} /> : !gstr3b ? (
            <div className="prm-empty"><div className="icon"><Icon name="ticket" size={44} /></div><h3>No GSTR-3B data</h3><p>Nothing found for {period}.</p></div>
          ) : (
            <>
              <div className="ga-actions">
                <div className="prm-section-title">GSTR-3B summary — {period}</div>
                <div className="ga-dl">
                  <button className="prm-btn ghost sm" onClick={() => download(downloadGSTR3BCSV, `GSTR3B_${month}_${year}.csv`, 'GSTR-3B CSV')}><Icon name="download" size={14} /> CSV</button>
                  <button className="prm-btn ghost sm" onClick={() => download(downloadGSTR3BPDF, `GSTR3B_${month}_${year}.pdf`, 'GSTR-3B PDF')}><Icon name="download" size={14} /> PDF</button>
                </div>
              </div>
              <ReturnSections data={gstr3b} />
            </>
          )
        )}

        {/* ================= INVOICES ================= */}
        {activeTab === 'invoices' && (
          <>
            <div className="prm-toolbar">
              <div className="prm-toolbar-left gst-filters">
                <div className="prm-search ga-search">
                  <Icon name="search" size={17} />
                  <input type="text" placeholder="Search invoice number or PNR on this page…" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
                  {searchTerm && <button className="prm-search-clear" onClick={() => setSearchTerm('')}>×</button>}
                </div>
                <select className="prm-input prm-select" value={statusFilter} onChange={e => { setStatusFilter(e.target.value); setPage(1); }}>
                  <option value="">All statuses</option>
                  <option value="active">Active</option>
                  <option value="cancelled">Cancelled</option>
                  <option value="credit_note">Credit note</option>
                </select>
              </div>
              <div className="prm-toolbar-right"><span className="prm-result-count">Showing <b>{visibleInvoices.length}</b> of {total}</span></div>
            </div>

            {loading && invoices.length === 0 ? <Skeleton /> : visibleInvoices.length === 0 ? (
              <div className="prm-empty">
                <div className="icon"><Icon name="wallet" size={44} /></div>
                <h3>No invoices found</h3><p>{searchTerm || statusFilter ? 'Try a different search or filter.' : 'Generate invoices to see them here.'}</p>
                {(searchTerm || statusFilter) && <button className="prm-btn ghost" onClick={() => { setSearchTerm(''); setStatusFilter(''); setPage(1); }}>Clear filters</button>}
              </div>
            ) : (
              <div className="prm-table-wrap">
                <table className="prm-table">
                  <thead><tr><th>Invoice no.</th><th>PNR</th><th>Date</th><th>Route</th><th className="ga-r">Taxable</th><th className="ga-r">CGST</th><th className="ga-r">SGST</th><th className="ga-r">Total</th><th>Status</th><th>Actions</th></tr></thead>
                  <tbody>
                    {visibleInvoices.map((inv, i) => (
                      <tr key={inv._id} style={{ animationDelay: `${i * 40}ms` }}>
                        <td><b>{inv.invoiceNumber}</b></td>
                        <td><span className="pbo-plate">{inv.pnr || 'N/A'}</span></td>
                        <td>{fmtDate(inv.invoiceDate)}</td>
                        <td>{inv.booking?.route?.from || '—'} → {inv.booking?.route?.to || '—'}</td>
                        <td className="ga-r">{inr(inv.totalTaxableValue)}</td>
                        <td className="ga-r">{inr(inv.totalCGST)}</td>
                        <td className="ga-r">{inr(inv.totalSGST)}</td>
                        <td className="ga-r"><b>{inr(inv.totalInvoiceValue)}</b></td>
                        <td><StatusPill value={inv.status} /></td>
                        <td>
                          <div className="prm-row-actions">
                            <button className="prm-btn view sm icon-only" onClick={() => openInvoice(inv._id)} title="View" aria-label="View"><Icon name="eye" size={14} /></button>
                            {inv.status === 'active' && <button className="prm-btn ghost sm gst-danger icon-only" onClick={() => startCancel(inv)} title="Cancel" aria-label="Cancel"><Icon name="x" size={14} /></button>}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            <Pagination page={page} pageSize={pageSize} total={total}
              onPage={p => setPage(Math.min(Math.max(1, p), totalPages))}
              onPageSize={s => { setPageSize(s); setPage(1); }}
              sizes={[10, 20, 50, 100]} label="invoices" />
          </>
        )}

        {/* ================= RATES ================= */}
        {activeTab === 'rates' && (
          <>
            <div className="prm-section-title">GST rates configuration</div>
            <div className="prm-table-wrap">
              <table className="prm-table">
                {rates.length > 0 ? (
                  <>
                    <thead><tr><th>Service</th><th>Tax</th><th className="ga-r">Rate</th><th>HSN/SAC</th><th>Status</th></tr></thead>
                    <tbody>{rates.map((r, i) => (
                      <tr key={r._id || i}>
                        <td>{r.serviceType}</td>
                        <td><span className={`gst-tax ${(r.taxType || '').toLowerCase()}`}>{r.taxType}</span></td>
                        <td className="ga-r"><span className="gst-rate">{r.rate}%</span></td>
                        <td>{r.hsnSacCode || 'N/A'}</td>
                        <td><span className={`prm-status ${r.isActive === false ? 'inactive' : 'active'}`}>{r.isActive === false ? 'Inactive' : 'Active'}</span></td>
                      </tr>
                    ))}</tbody>
                  </>
                ) : (
                  <>
                    <thead><tr><th>Service</th><th>Supply</th><th className="ga-r">GST</th><th className="ga-r">CGST</th><th className="ga-r">SGST</th><th>Status</th></tr></thead>
                    <tbody>{referenceRates.map(([s, t, g, c, sg, st], i) => (
                      <tr key={i}><td>{s}</td><td>{t}</td><td className="ga-r"><span className="gst-rate">{g}</span></td><td className="ga-r">{c}</td><td className="ga-r">{sg}</td>
                        <td><span className={`prm-status ${st === 'Active' ? 'active' : 'pending'}`}>{st}</span></td></tr>
                    ))}</tbody>
                  </>
                )}
              </table>
            </div>
            <div className="ga-alert info">
              <Icon name="info" size={20} />
              <div><b>GST rates applied</b><p>AC buses @ 5% (IGST or CGST + SGST) · Non-AC buses @ 0% (exempt) · Luxury coaches @ 12%.{rates.length === 0 ? ' Showing reference rates.' : ''}</p></div>
            </div>
          </>
        )}
      </div>

      {/* ================= INVOICE MODAL ================= */}
      {viewInvoice && (
        <div className="prm-overlay" onClick={() => setViewInvoice(null)}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={e => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="wallet" size={22} /></span>
                <div><h3>{viewInvoice.invoiceNumber}</h3><p>PNR {viewInvoice.pnr || 'N/A'}</p></div>
              </div>
              <button className="prm-modal-close" onClick={() => setViewInvoice(null)}>×</button>
            </div>
            <div className="prm-form-body">
              <div className="pbo-mini-stats">
                <div><span>Status</span><b><StatusPill value={viewInvoice.status} /></b></div>
                <div><span>Date</span><b>{fmtDate(viewInvoice.invoiceDate)}</b></div>
                <div><span>FY</span><b>{viewInvoice.financialYear || 'N/A'}</b></div>
                <div><span>Inter-state</span><b>{viewInvoice.isInterState ? 'Yes' : 'No'}</b></div>
              </div>
              <div className="gst-details">
                <div><span>Recipient</span><b>{viewInvoice.recipient?.name || 'N/A'}</b></div>
                <div><span>Place of supply</span><b>{viewInvoice.placeOfSupply?.stateName || 'N/A'}</b></div>
              </div>
              <div className="gst-result-rows ga-invoice-rows">
                <div><span>Taxable value</span><b>{inr(viewInvoice.totalTaxableValue)}</b></div>
                <div><span>CGST</span><b>{inr(viewInvoice.totalCGST)}</b></div>
                <div><span>SGST</span><b>{inr(viewInvoice.totalSGST)}</b></div>
                <div className="sum"><span>Total invoice value</span><b>{inr(viewInvoice.totalInvoiceValue)}</b></div>
              </div>
              {viewInvoice.notes && <p className="gst-hint">Notes: {viewInvoice.notes}</p>}
            </div>
            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => setViewInvoice(null)}>Close</button>
                {viewInvoice.status === 'active' && <button className="prm-btn primary gst-danger-solid" onClick={() => startCancel(viewInvoice)}>Cancel invoice</button>}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ================= CANCEL MODAL ================= */}
      {cancelTarget && (
        <div className="prm-overlay" onClick={() => !cancelling && setCancelTarget(null)}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={e => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="info" size={22} /></span>
                <div><h3>Cancel invoice</h3><p>{cancelTarget.invoiceNumber} · a credit note will be created</p></div>
              </div>
              <button className="prm-modal-close" onClick={() => setCancelTarget(null)}>×</button>
            </div>
            <div className="prm-form-body">
              <Field label="Cancellation reason" required>
                <textarea className="prm-input gst-textarea" rows="3" autoFocus value={cancelReason} onChange={e => setCancelReason(e.target.value)} placeholder="Why is this invoice being cancelled?" />
              </Field>
            </div>
            <div className="prm-form-foot">
              <span className="prm-foot-hint">This action cannot be undone</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => setCancelTarget(null)} disabled={cancelling}>Keep invoice</button>
                <button className="prm-btn primary gst-danger-solid" onClick={confirmCancel} disabled={cancelling}>{cancelling ? 'Cancelling…' : 'Cancel invoice'}</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GSTAdminPanel;